// Color palette for igloos — each igloo gets a unique color (wraps after 10)
// Each entry has Tailwind classes for various states

const iglooColorPalette = [
  { // Blue
    dot: 'bg-blue-500 border-blue-500',
    dotHover: 'hover:bg-blue-200 hover:border-blue-300',
    badge: 'bg-blue-500',
    badgeRing: 'ring-blue-200',
  },
  { // Green
    dot: 'bg-green-500 border-green-500',
    dotHover: 'hover:bg-green-200 hover:border-green-300',
    badge: 'bg-green-500',
    badgeRing: 'ring-green-200',
  },
  { // Orange
    dot: 'bg-orange-500 border-orange-500',
    dotHover: 'hover:bg-orange-200 hover:border-orange-300',
    badge: 'bg-orange-500',
    badgeRing: 'ring-orange-200',
  },
  { // Purple
    dot: 'bg-purple-500 border-purple-500',
    dotHover: 'hover:bg-purple-200 hover:border-purple-300',
    badge: 'bg-purple-500',
    badgeRing: 'ring-purple-200',
  },
  { // Rose
    dot: 'bg-rose-500 border-rose-500',
    dotHover: 'hover:bg-rose-200 hover:border-rose-300',
    badge: 'bg-rose-500',
    badgeRing: 'ring-rose-200',
  },
  { // Teal
    dot: 'bg-teal-500 border-teal-500',
    dotHover: 'hover:bg-teal-200 hover:border-teal-300',
    badge: 'bg-teal-500',
    badgeRing: 'ring-teal-200',
  },
  { // Amber
    dot: 'bg-amber-500 border-amber-500',
    dotHover: 'hover:bg-amber-200 hover:border-amber-300',
    badge: 'bg-amber-500',
    badgeRing: 'ring-amber-200',
  },
  { // Indigo
    dot: 'bg-indigo-500 border-indigo-500',
    dotHover: 'hover:bg-indigo-200 hover:border-indigo-300',
    badge: 'bg-indigo-500',
    badgeRing: 'ring-indigo-200',
  },
  { // Cyan
    dot: 'bg-cyan-500 border-cyan-500',
    dotHover: 'hover:bg-cyan-200 hover:border-cyan-300',
    badge: 'bg-cyan-500',
    badgeRing: 'ring-cyan-200',
  },
  { // Pink
    dot: 'bg-pink-500 border-pink-500',
    dotHover: 'hover:bg-pink-200 hover:border-pink-300',
    badge: 'bg-pink-500',
    badgeRing: 'ring-pink-200',
  },
];

export function getIglooColor(index) {
  return iglooColorPalette[index % iglooColorPalette.length];
}

export default iglooColorPalette;
